export function formatBytes(bytes: number) {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** exponent;
  return `${value.toFixed(value >= 10 || exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

export function baseName(filename: string) {
  return filename.replace(/\.[^.]+$/, "");
}

export function getExtension(filename: string) {
  return filename.split(".").pop()?.toLowerCase() || "jpg";
}